import React from 'react';

import { IconMarker } from '../../../components';

import css from './ListingAddressText.module.css';

const ListingAddressText = ({ listing }) => {
  const address = listing.attributes.publicData.address_in_listing;
  if (!listing || !address) return null;

  return (
    <div className={css.root}>
      <IconMarker className={css.addressMarker} />
      <div className={css.listingAddressWrapper}>
        <p className={css.listingAddress}>{address}</p>
      </div>
    </div>
  );
};

export default ListingAddressText;
